module.exports = __webpack_public_path__ + "img/homePageimg3.9d38f248.png";